import styled from 'styled-components';

import { Form } from 'devextreme-react';


const LoginContentStyledBse = styled.div`
  background: url('images/logo.back.svg') center center no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 20px;
`;

const LoginContentStyled =
    __VISUELSE__
    ? styled(LoginContentStyledBse)`
        background: url('images/login-bg.png') center center no-repeat;
        background-size: cover;
      `
    : styled(LoginContentStyledBse)``
;


const LoginPageStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 5vw;
  min-height: 100vh;
`;


const LoginPageModalBoxStyled = styled.div`
  max-width: 350px;
`;


const LoginPageLogoStyled = styled.img`
  max-width: 70%;
  height: auto;
  margin: 0 auto 30px auto;
  display: block;
`;


const LoginPageLabelStyled = styled.label`
  display: inline-block;
  margin-bottom: 10px;
`;


const LoginPageInputStyled = styled.input`
  -moz-border-radius: 0.25rem;
  -webkit-border-radius: 0.25rem;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 0.25rem;
  border: solid 1px #04aa9d;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
  color: inherit;
  font-family: inherit;
  font-size: smaller;
  height: 2.5rem;
  line-height: 1;
  margin: 0 0 1.5rem 0;
  padding: 0 0.75rem;
  width: 100%;
`;


const LoginPageButtonStyled = styled.button`
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.25rem;
  border: solid 1px #FF6700;
  color: #FF6700;
  cursor: pointer;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  height: 2.5rem;
  line-height: 2.5rem;
  margin-bottom: 30px;
  overflow: hidden;
  padding: 0 0.5rem;
  position: relative;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  width: 10rem;
  &:hover {
    color: #04aa9d;
    border: solid 1px #04aa9d;
  }
`;





const FormStyled = styled(Form)`
    margin: 0px 32px;
`;


const ErrorText = styled.span`
    color: red;
`;

export {
    FormStyled, ErrorText,
    LoginContentStyled,
    LoginPageStyled,
    LoginPageModalBoxStyled,
    LoginPageLogoStyled,
    LoginPageLabelStyled,
    LoginPageInputStyled,
    LoginPageButtonStyled,
}